export enum NightShiftType {
  Yes = 'yes',
  No = 'no',
  OnlyTz = 'nightshift_only_tz',
  OnlyPfk = 'nightshift_only_pfk',
}

export const NIGHT_SHIFT_TYPE_TRANSLATIONS = {
  [NightShiftType.Yes]: 'Ja',
  [NightShiftType.No]: 'Nein',
  [NightShiftType.OnlyTz]: 'DNW nur in TZ',
  [NightShiftType.OnlyPfk]: 'DNW nur für PFK',
};
